// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","headerContainer":"Header_headerContainer__W-fqr","navMenu":"Header_navMenu__8aHNB","mobileActiveMenu":"Header_mobileActiveMenu__FGl5P"};